<div class="min-h-screen bg-gray-50">
      <app-header [cartCount]="cartCount"></app-header>

      <!-- Hero Section -->
      <section class="bg-gradient-to-br from-orange-50 via-white to-red-50 py-12">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center">
            <span class="inline-flex items-center bg-orange-100 text-orange-600 rounded-full px-4 py-1 text-sm font-medium mb-4">
              <lucide-icon name="message-circle" class="w-4 h-4 mr-1"></lucide-icon>
              We're Here to Help
            </span>
            <h1 class="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Contact <span class="text-orange-500">Us</span>
            </h1>
            <p class="text-xl text-gray-600 max-w-2xl mx-auto">
              Have questions or feedback? We'd love to hear from you!
            </p>
          </div>
        </div>
      </section>

      <!-- Contact Info Cards -->
      <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div *ngFor="let info of contactInfo" class="bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow">
            <div class="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mb-3">
              <lucide-icon [name]="info.icon" class="w-6 h-6 text-orange-500"></lucide-icon>
            </div>
            <h3 class="font-semibold text-gray-900 mb-1">{{ info.title }}</h3>
            <a *ngIf="info.link" [href]="info.link" class="text-gray-600 hover:text-orange-500 transition-colors">{{ info.value }}</a>
            <p *ngIf="!info.link" class="text-gray-600">{{ info.value }}</p>
          </div>
        </div>
      </section>

      <!-- Main Content -->
      <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <!-- Contact Form -->
          <div>
            <h2 class="text-2xl font-bold text-gray-900 mb-6">Send us a Message</h2>
            
            <div *ngIf="submitted" class="bg-green-50 border border-green-200 rounded-xl p-6 text-center">
              <div class="w-16 h-16 bg-green-100 rounded-full mx-auto flex items-center justify-center mb-4">
                <lucide-icon name="send" class="w-8 h-8 text-green-600"></lucide-icon>
              </div>
              <h3 class="text-xl font-bold text-green-800 mb-2">Message Sent!</h3>
              <p class="text-green-600">We'll get back to you within 24 hours.</p>
            </div>
            
            <form *ngIf="!submitted" (ngSubmit)="handleSubmit()" class="bg-white rounded-2xl p-6 border border-gray-300 rounded-2xl p-6 shadow-sm">
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Name</label>
                  <input type="text" [(ngModel)]="formData.name" name="name" required 
                         class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:border-orange-500" />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input type="email" [(ngModel)]="formData.email" name="email" required 
                         class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:border-orange-500" />
                </div>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                  <input type="tel" [(ngModel)]="formData.phone" name="phone"
                         class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:border-orange-500" />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                  <input type="text" [(ngModel)]="formData.subject" name="subject" placeholder="How can we help?" required 
                         class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:border-orange-500" />
                </div>
              </div>
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea [(ngModel)]="formData.message" name="message" placeholder="Tell us more about your query..." rows="6" required 
                          class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:border-orange-500 resize-none"></textarea>
              </div>
              <button type="submit" class="w-full bg-orange-500 hover:bg-orange-600 text-white rounded-full py-3 font-semibold">
                Send Message
              </button>
            </form>
          </div>

          <!-- FAQs -->
          <!-- <div>
            <h2 class="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <lucide-icon name="help-circle" class="w-6 h-6 mr-2 text-orange-500"></lucide-icon>
              Frequently Asked Questions
            </h2>
            <div class="space-y-3">
              <div *ngFor="let faq of faqs; let i = index" class="bg-white rounded-xl shadow-sm overflow-hidden">
                <button (click)="toggleFaq(i)" 
                        class="w-full px-5 py-4 text-left font-medium text-gray-900 flex justify-between items-center hover:bg-gray-50">
                  {{ faq.question }}
                  <lucide-icon name="chevron-down" [class.rotate-180]="openFaq === i" class="w-5 h-5 transition-transform"></lucide-icon>
                </button>
                <div *ngIf="openFaq === i" class="px-5 pb-4 text-gray-600">
                  {{ faq.answer }}
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </section>

      <app-footer></app-footer>
    </div>